import {Component, Injector} from "@angular/core";
import {provideSearchModel} from "@fedeltapointofsale/data-client";
import {
    AbstractSelectSearchControlComponent
} from "../../../framework/entity/search/search-controls/select-search-controls/abstract-select-search-control.component";
import {
    registerSearchControl
} from "../../../framework/entity/search/search-controls/abstract-search-control.component";
import {WebTerminalSearchModel} from "../web-terminal-search.model";
import {WebTerminalSearchPageComponent} from "../web-terminal-search-page/web-terminal-search-page.component";

@Component({
    selector: "wbo-web-terminal-multi-select-search-control",
    templateUrl: "../../../framework/entity/search/search-controls/select-search-controls/multi-select-search-control.component.html",
    providers: [
        provideSearchModel(WebTerminalSearchModel),
        registerSearchControl(WebTerminalMultiSelectSearchControlComponent)
    ]
})

export class WebTerminalMultiSelectSearchControlComponent extends AbstractSelectSearchControlComponent<WebTerminalSearchModel> {
    constructor(model: WebTerminalSearchModel, injector: Injector) {
        super(model, injector, "webTerminalId", "webTerminalName");
        this.extendedSearchComponent = WebTerminalSearchPageComponent;
    }
}
